


























import { ItemCategory } from "@/services/api-client-generated";
import { i18n } from "@/plugins/i18n";

export default {
  name: "CategoryBreadCrumbs",
  props: {
    items: {
      type: Array as () => ItemCategory[],
      required: true
    }
  },
  methods: {
    getCategoryTranslation(item) {
      if (item.vertalingen && item.vertalingen.hasOwnProperty(i18n.locale)) {
        return item.vertalingen[i18n.locale];
      }

      return item.displayName;
    }
  }
};
